import { useEffect } from 'react'
import { useAuth } from '@/lib/AuthContext'
import { supabase } from '@/lib/supabase'

export function usePushNotifications() {
  const { user, profile } = useAuth()

  useEffect(() => {
    if (!user || !window.OneSignalDeferred) return

    // Only run OneSignal on production domain
    const isProduction = window.location.hostname.includes('earthtrackr.com')
    if (!isProduction) {
      console.log('OneSignal disabled on localhost')
      return
    }

    window.OneSignalDeferred.push(async (OneSignal) => {
      try {
        await OneSignal.login(user.id)

        await OneSignal.User.addTags({
          is_pro: profile?.is_pro ? 'true' : 'false',
          email: user.email,
        })

        const playerId = OneSignal.User.PushSubscription.id
        if (playerId) {
          await supabase
            .from('profiles')
            .update({ onesignal_player_id: playerId })
            .eq('id', user.id)
        }

        OneSignal.User.PushSubscription.addEventListener('change', async (event) => {
          if (event.current.id) {
            await supabase
              .from('profiles')
              .update({ onesignal_player_id: event.current.id })
              .eq('id', user.id)
          }
        })
      } catch (err) {
        console.error('OneSignal setup error:', err)
      }
    })
  }, [user, profile?.is_pro])

  const requestPermission = () => {
    if (!window.OneSignalDeferred) return
    window.OneSignalDeferred.push(async (OneSignal) => {
      await OneSignal.Notifications.requestPermission()
    })
  }

  return { requestPermission }
}